<template>
  <v-app :style="{ height: standalone ? '100vh' : 'inherit' }">
    <component
      :is="!$vuetify.breakpoint.xs ? 'vue-draggable' : 'div'"
      :drag-handle="'#' + dragHandleID"
      style="z-index: 10000"
      :style="panelStyle"
      w="auto"
      h="auto"
    >
      <v-container
        fill-height
        fluid
        justify="center"
        :style="{
          padding: $vuetify.breakpoint.smAndDown ? '0' : 'inherit',
        }"
      >
        <v-layout wrap>
          <v-flex>
            <v-card
              elevation="4"
              light
              tag="section"
              :class="{ 'rounded-xl': !$vuetify.breakpoint.smAndDown }"
              :style="{
                minHeight: '150px',
              }"
            >
              <template v-if="sip">
                <div
                  :id="dragHandleID"
                  class="green lighten-5 px-10"
                  style="cursor: move"
                >
                  <v-btn
                    v-if="!standalone"
                    fab
                    icon
                    fixed
                    top
                    right
                    small
                    outlined
                    color="red"
                    class="red lighten-4"
                    title="Закрыть"
                    @click="close"
                  >
                    <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                      <path
                        fill="currentColor"
                        d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
                      />
                    </svg>
                  </v-btn>
                  <v-card-title>
                    <v-layout align-center justify-center>
                      <span style="word-break: break-word">
                        {{ description }}
                      </span>
                    </v-layout>
                  </v-card-title>
                  <v-card-subtitle>
                    <v-layout align-center justify-center>
                      {{ number }}
                    </v-layout>
                  </v-card-subtitle>
                </div>
                <v-divider></v-divider>
                <v-card-actions
                  :class="{ 'pa-3': $vuetify.breakpoint.smAndUp }"
                >
                  <v-flex>
                    <div align="center">
                      <template v-if="sip">
                        <template v-if="login">
                          <template v-if="sip.state == 0">
                            <div v-if="error" class="red--text">
                              {{ error.message.text }}
                            </div>
                            <div v-else-if="state">
                              {{ state.description.tip }}
                            </div>
                            <v-btn
                              title="Переподключиться"
                              icon
                              @click="reconnect"
                            >
                              <svg
                                style="width: 24px; height: 24px"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="currentColor"
                                  d="M2 12C2 16.97 6.03 21 11 21C13.39 21 15.68 20.06 17.4 18.4L15.9 16.9C14.63 18.25 12.86 19 11 19C4.76 19 1.64 11.46 6.05 7.05C10.46 2.64 18 5.77 18 12H15L19 16H19.1L23 12H20C20 7.03 15.97 3 11 3C6.03 3 2 7.03 2 12Z"
                                />
                              </svg>
                            </v-btn>
                          </template>
                          <template v-if="sip.state == 1">
                            <v-progress-circular
                              indeterminate
                            ></v-progress-circular>
                          </template>
                          <template v-else-if="sip.state == 2">
                            <v-btn
                              icon
                              class="green lighten-5"
                              x-large
                              title="Начать звонок"
                              @click="dial"
                            >
                              <svg
                                color="green"
                                style="width: 24px; height: 24px"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="currentColor"
                                  d="M20,15.5C18.8,15.5 17.5,15.3 16.4,14.9C16.3,14.9 16.2,14.9 16.1,14.9C15.8,14.9 15.6,15 15.4,15.2L13.2,17.4C10.4,15.9 8,13.6 6.6,10.8L8.8,8.6C9.1,8.3 9.2,7.9 9,7.6C8.7,6.5 8.5,5.2 8.5,4C8.5,3.5 8,3 7.5,3H4C3.5,3 3,3.5 3,4C3,13.4 10.6,21 20,21C20.5,21 21,20.5 21,20V16.5C21,16 20.5,15.5 20,15.5M5,5H6.5C6.6,5.9 6.8,6.8 7,7.6L5.8,8.8C5.4,7.6 5.1,6.3 5,5M19,19C17.7,18.9 16.4,18.6 15.2,18.2L16.4,17C17.2,17.2 18.1,17.4 19,17.4V19Z"
                                />
                              </svg>
                            </v-btn>
                          </template>
                          <template v-else-if="sip.state == 3">
                            <v-btn
                              icon
                              class="red lighten-5"
                              x-large
                              title="Завершить звонок"
                              @click="hangup"
                            >
                              <svg
                                color="red"
                                style="width: 24px; height: 24px"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="currentColor"
                                  d="M23.71 11.67A17 17 0 0 0 .29 11.67A1 1 0 0 0 0 12.38A1 1 0 0 0 .29 13.08L2.77 15.56A1 1 0 0 0 3.5 15.85A1 1 0 0 0 4.18 15.57A11.5 11.5 0 0 1 6.84 13.72A1 1 0 0 0 7.4 12.82V9.72A14.91 14.91 0 0 1 12 9A14.5 14.5 0 0 1 16.59 9.73V12.83A1 1 0 0 0 17.15 13.73A11.27 11.27 0 0 1 19.82 15.58A1 1 0 0 0 20.5 15.86A1 1 0 0 0 21.23 15.57L23.71 13.09A1 1 0 0 0 23.71 11.67M5.4 12.22A13.68 13.68 0 0 0 3.53 13.5L2.46 12.42A15.54 15.54 0 0 1 5.4 10.5M20.5 13.5A13.75 13.75 0 0 0 18.6 12.23V10.53A14.26 14.26 0 0 1 21.55 12.43Z"
                                />
                              </svg>
                            </v-btn>
                          </template>
                        </template>
                        <template v-else>
                          <span v-if="loaded" class="red--text">
                            Для Вашей учётной записи не настроены звонки.
                          </span>
                        </template>
                      </template>
                    </div>
                  </v-flex>
                </v-card-actions>
              </template>
              <template v-else>
                <v-overlay color="transparent">
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      color="black"
                      indeterminate
                    ></v-progress-circular>
                  </v-row>
                </v-overlay>
              </template>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <audio id="sip-localAudio" autoPlay muted></audio>
      <audio id="sip-remoteAudio" autoPlay></audio>
      <audio id="sip-sounds" autoPlay></audio>
    </component>
  </v-app>
</template>

<script>
import VueDraggable from "vue-draggable-resizable";
import { loadScript, unloadScript } from "vue-plugin-load-script";

import vuetify from "@/plugins/vuetify";
import { voip_login } from "@/api/voip";

const externalScripts = [
  "https://ru-tel.com/c/components/com_rtang/scripts/utils/bowser.min.js",
  "https://ru-tel.com/c/components/com_rtang/scripts/sip/sipml.min.214.js",
  "https://ru-tel.com/c/components/com_rtang/scripts/sip/jssip.min.js",
  "https://ru-tel.com/c/components/com_rtang/scripts/utils/rt-sipwrapper.js",
  "https://ru-tel.com/c/components/com_rtang/scripts/utils/rt-sipwrapper-jssip.js",
  "https://ru-tel.com/c/components/com_rtang/scripts/utils/rt-sipwrapper-sipml5.js",
];

export default {
  vuetify,
  components: { VueDraggable },
  props: {
    call_id: {
      type: String,
      default: "",
    },
    standalone: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["stateChange"],
  data() {
    return {
      sip: null,
      error: null,
      state: null,
      initialized: false,
      description: "",
      number: "",
      login: "",
      password: "",
      loaded: false,
    };
  },
  computed: {
    dragHandleID() {
      const prefix = `callframe_${this._uid}`;
      if (!this.number) {
        return prefix;
      }

      return `${prefix}_${this.number.replace(/\D/g, "")}`;
    },
    panelStyle() {
      const l = {
        position: "fixed",
      };
      if (this.$vuetify.breakpoint.xs) {
        l.width = "100%";
        l.bottom = "0";
        l.left = "0";
        l.transform = "translate(0px, 0px)";
      } else {
        l.maxWidth = "400px";
        l.bottom = "1vh";
        l.right = "3vh";
      }

      return l;
    },
  },
  watch: {
    call_id() {
      this.disconnect();

      voip_login(this.call_id)
        .then((response) => {
          if (response.result == "Ok") {
            this.number = response.number;
            this.description = response.description;
            this.login = response.login;
            this.password = response.password;
            this.connect();

            this.initialized = true;
          }
        })
        .finally(() => {
          this.loaded = true;
        });
    },
  },
  mounted() {
    this.init();
  },
  async beforeDestroy() {
    this.disconnect();
    await this.unloadScripts();
  },
  methods: {
    async init() {
      if (this.initialized) {
        return;
      }

      await this.loadScripts();

      let soundOptions = {
        localAudio: this.$root.$el.querySelector("#sip-localAudio"),
        remoteAudio: this.$root.$el.querySelector("#sip-remoteAudio"),
        sounds: this.$root.$el.querySelector("#sip-sounds"),
        soundFiles: {
          answered:
            "https://ru-tel.com/c/components/com_rtang/sounds/answered.mp3",
          rejected:
            "https://ru-tel.com/c/components/com_rtang/sounds/rejected.mp3",
          ringback:
            "https://ru-tel.com/c/components/com_rtang/sounds/ringback.mp3",
          ringing:
            "https://ru-tel.com/c/components/com_rtang/sounds/ringing.mp3",
        },
      };
      // eslint-disable-next-line no-undef
      this.sip = new RTSipWrapper(soundOptions, null, null, true);
      this.sip.onError((context, event, message) => {
        this.error = { context, event, message };
      });
      this.sip.onStateChanged((state, description) => {
        // this.state = { state: state, description: description };
        // this.$emit("stateChange", this.state);
      });

      voip_login(this.call_id)
        .then((response) => {
          if (response.result == "Ok") {
            this.number = response.number;
            this.description = response.description;
            this.login = response.login;
            this.password = response.password;
            this.connect();

            this.initialized = true;
          }
        })
        .finally(() => {
          this.loaded = true;
        });
    },
    reconnect() {
      if (this.sip) {
        this.sip.reconnect();
      }
    },
    connect() {
      if (this.sip) {
        this.sip.connect(this.login, this.password);
      }
    },
    disconnect() {
      if (this.sip) {
        this.sip.disconnect();
      }
    },
    dial() {
      if (this.sip) {
        this.sip.dial(this.number);
      }
    },
    hangup() {
      if (this.sip) {
        this.sip.hangUp();
      }
    },
    close() {
      this.$emit("close");
    },
    async loadScripts() {
      for (const s of externalScripts) {
        await loadScript(s);
      }
    },
    async unloadScripts() {
      for (const s of externalScripts) {
        await unloadScript(s);
      }
    },
  },
};
</script>

<style>
#app {
  background: transparent;
}

#app > div {
  min-height: unset;
}
</style>
